import AdvanceReEligibilityScreen from 'features/advance/screens/advanceStatusScreens/AdvanceReEligiblity/AdvanceReEligibilityScreen';
import React from 'react';

const AdvanceReEligibilityPage = () => {
  return <AdvanceReEligibilityScreen />;
};

export default AdvanceReEligibilityPage;
